module.exports = __webpack_public_path__ + "img/logo-im-white.3d2ec076.png";